var _rect, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitGlassIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    width: 45,
    height: 45,
    rx: 5,
    fill: "#393184"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_406_180)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 5,
    transform: "matrix(-1 0 0 1 45 6)",
    fill: "#E2DFFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    y: 0.25,
    width: 44.5,
    height: 44.5,
    rx: 4.75,
    transform: "matrix(-1 0 0 1 44.5 6)",
    stroke: "url(#paint0_linear_406_180)",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5231 16.5L19.7275 25.4901L16 27.492C16 27.492 27.2626 29.2295 36 35.5L28.3046 27.832L33.3546 19.8619L24.6573 23.6013L17.5231 16.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98546 32.2859C7.98546 32.2859 7.21986 31.7946 7.05181 31.0198C6.41336 28.072 11.8532 28.4406 13.6152 28.6154C19.4721 29.1964 28.6186 31.7051 36 36.5C36 36.5 29.0307 33.2465 25.5462 32.2859L22.6827 36.3451L21.2337 31.1704C21.2337 31.1704 6.15703 27.1422 7.98546 32.2859Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_406_180",
    x: -8,
    y: -2,
    width: 61,
    height: 61,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_406_180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_406_180",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_180",
    x1: 75.5,
    y1: 21.5,
    x2: 40,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C60F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitGlassIcon2);
export default __webpack_public_path__ + "static/media/unit-glass-icon2.821e79a7f3bd39dc017103297e3b754b.svg";
export { ForwardRef as ReactComponent };